/**
 * API client functions for vendor operations (Phase 1a).
 */

import { API_BASE_URL } from '../config/api';
import type { Vendor } from '../types/inventory';

function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

export type VendorCreatePayload = {
  name: string;
  vendor_code?: string | null;
  contact_name?: string | null;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  payment_terms?: string | null;
  average_lead_time_days?: number | null;
  discount_percentage?: string | null;
  account_number?: string | null;
  notes?: string | null;
};

export async function listVendors(
  practiceId: string,
  opts?: { include_inactive?: boolean; search?: string }
): Promise<Vendor[]> {
  const params = new URLSearchParams();
  if (opts?.include_inactive) params.append('include_inactive', 'true');
  if (opts?.search) params.append('search', opts.search);

  const response = await fetch(
    `${API_BASE_URL}/api/v1/practices/${practiceId}/vendors?${params.toString()}`,
    { method: 'GET', headers: getAuthHeaders() }
  );
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to fetch vendors' }));
    throw new Error(error.detail || 'Failed to fetch vendors');
  }
  return response.json();
}

export async function createVendor(practiceId: string, payload: VendorCreatePayload): Promise<Vendor> {
  const response = await fetch(`${API_BASE_URL}/api/v1/practices/${practiceId}/vendors`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to create vendor' }));
    throw new Error(error.detail || 'Failed to create vendor');
  }
  return response.json();
}


